import { useState, useEffect } from 'react';

export const useParallax = (strength = 20) => {
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  
  useEffect(() => {
    const handleMouseMove = (e) => {
      const x = (e.clientX - window.innerWidth / 2) / strength;
      const y = (e.clientY - window.innerHeight / 2) / strength;
      setOffset({ x, y });
    };
    
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, [strength]);
  
  return offset;
};
